module.exports = __webpack_public_path__ + "img/fa-havlicek.dc025e1f.jpg";